import { render } from "./RequestIcon.vue?vue&type=template&id=23bea0ea"
const script = {}
script.render = render

export default script